import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { TokenInterceptorService } from '@shared/token-interceptor';
import { AuthModule } from 'libs/shared/web/auth/auth.module';
import { FormsModule } from 'libs/shared/web/forms/forms.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
// import { AdminModule } from 'libs/shared/web/admin/admin.module';
import { CommonModule } from '@angular/common';
import { STORE_RUNTIME_CHECKS } from '@common/interfaces';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { AdminModule } from 'libs/shared/web/dashboard/admin/admin.module';
import { DashboardRoutingModule } from 'libs/shared/web/dashboard/dashboard-routing.module';
import { DashboardModule } from 'libs/shared/web/dashboard/dashboard.module';
import { EmployeeModule } from 'libs/shared/web/dashboard/employee/employee.module';
import { WorkspaceOwnerModule } from 'libs/shared/web/dashboard/workspace-owner/workspace-owner.module';
import { NgChartsModule } from 'ng2-charts';
import { environment } from 'src/environments/environment';
import { searchStateReducer } from 'store/search-state/search.reducer';
import { reducers } from './app.state';
// import { UserModule } from 'libs/shared/web/user/user.module';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ReactiveFormsModule,
    RouterModule,
    AuthModule,
    FormsModule,
    HttpClientModule,
    DashboardRoutingModule,
    DashboardModule,
    CommonModule,
    EmployeeModule, WorkspaceOwnerModule,
    AdminModule,
    NgChartsModule,
    BrowserAnimationsModule,
    StoreModule.forRoot(reducers, {
      runtimeChecks: {
        ...STORE_RUNTIME_CHECKS
      }
    }),
    !environment.production ? StoreDevtoolsModule.instrument() : [],
    StoreModule.forFeature(
      searchStateReducer.searchFeatureKey,
      searchStateReducer.searchReducer
    )
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptorService,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
